module.exports = __webpack_public_path__ + "lato-black-webfont.680164d7790acc3c1891.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-black-webfont.svg
// module id = ../../../../../resources/layout/fonts/lato-black-webfont.svg
// module chunks = styles